export default {"src":"/_next/static/media/newsletter-arrow.ee8e96ea.svg","height":26,"width":42};